export const isEmptyValue = (value: any) => value === undefined || value === null;
